import "./TypingLoader.css";

const TypingLoader = () => {
  return (
    <div className="typing-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default TypingLoader;
